module.exports = __webpack_public_path__ + "static/media/banner_betgames-half.46b8193e.png";